import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHorizontalBars = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#427FF8"
      fillRule="evenodd"
      d="M9.53 4.225v4.741h6.248c.748 0 1.355-.606 1.355-1.354V5.58c0-.748-.607-1.355-1.355-1.355zm0 7.451v4.741h10.506c.748 0 1.354-.607 1.354-1.355V13.03c0-.748-.606-1.354-1.354-1.354zm0 7.45v4.741h13.243c.748 0 1.354-.606 1.354-1.354V20.48c0-.748-.606-1.355-1.354-1.355H9.53Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgHorizontalBars;
